var user = JSON.parse(localStorage.getItem('user') ?? "{}")

export default
  [
    {
      title: "الرئيسية",
      route: 'home',
      icon: 'HomeIcon',
    },
    {
      title: "الفواتير / الطلبات",
      route: 'orders',
      icon: 'InboxIcon',
    },
    {
      title: "التحكم في الأجهزة",
      route: 'devices',
      icon: 'ServerIcon',
    },
    {
      title: "الطلبات المعلقة",
      route: 'pending',
      icon: 'ClockIcon',
    },
    {
      title: "الإعدادات",
      route: 'settings',
      icon: 'SettingsIcon',
    },
    {
      title: "API Docs",
      route: 'api',
      icon: 'BookIcon',
    },
  ].filter(function(x){
    return x;
    if(user?.pers?.includes("*")){
      return x;
    }else{
      if(!x.per || user.pers.includes(x.per)){
        return x;
      }
    }
    return false;
  });
